export enum AssistanceApplicationTypeStrings {
    UHONS = 'UHONS',
    UFF = 'UFF',
    STLWater = 'StlWater',
    EFN = 'EFN',
    STLStorm = 'STLStorm',
}
